<script>
export default {
	baseUrl: 'gameglue.wxmolegames.com/activity/',//"127.0.0.1:8090/activity/",//
	imgBaseUrl: 'hwcdn.wxmolegames.com/gm/'//'http://gameoss.wxmolegames.com/GM/'//'http://gamemoleresources.oss-cn-shanghai.aliyuncs.com/GM/'
}
</script>